import { configure, defineRule } from "vee-validate";
import * as AllRules from "@vee-validate/rules";
import { localize } from "@vee-validate/i18n";
import en from "@vee-validate/i18n/dist/locale/en.json";
import ko from "@vee-validate/i18n/dist/locale/ko.json";

// Install all rules (함수인 것만 등록)
Object.keys(AllRules).forEach((rule) => {
  if (typeof AllRules[rule] === 'function') {
    defineRule(rule, AllRules[rule]);
  }
});

defineRule("mobilePhone", (value) => {
  let regPhone = /^\d{3}-\d{3,4}-\d{4}$/;

  if (!regPhone.test(value)) {
    return `휴대전화번호 형식이 올바르지 않습니다. 정확하게 다시 입력해주세요.`;
  }

  return true;
});

defineRule("emailCheck", (value) => {
  let regPhone = /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}$/i;

  if (!regPhone.test(value)) {
    return `이메일 형식이 올바르지 않습니다. 정확하게 다시 입력해주세요.`;
  }

  return true;
});

defineRule("passwordCheck", (value) => {
  // let passwordReg = /^[a-zA-Z0-9]{8,12}$/;
  let passwordReg = /^(?=.*[a-zA-Z])(?=.*\d)[a-zA-Z0-9]{8,12}$/;

  if (!passwordReg.test(value)) {
    return `비밀번호 형식이 올바르지 않습니다. 영문 + 숫자 8~12자리로 입력 부탁드립니다.`;
  }

  return true;
});

configure({
  generateMessage: localize({
    en: {
      messages: en.messages,
    },
    ko: {
      messages: ko.messages,
    },
  }),
});
